import { Routes } from '@angular/router';
import { pmsDashboardRedirectGuard } from 'src/pms/guards/pms-dashboard-redirect.guard';
import { LoginGuard } from 'src/shared/guards/login.guard';

export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [pmsDashboardRedirectGuard, LoginGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then((x) => x.DashboardComponent),
    title: 'Queue',
  },
  {
    path: 'submission/:id',
    canActivate: [LoginGuard],
    loadComponent: () =>
      import('./pages/submissionHistory/submission-history.component').then((x) => x.SubmissionHistoryComponent),
    title: 'Submission History',
  },
  {
    path: 'videocheck',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/videochecks/videochecks.component').then((x) => x.VideoChecksComponent),
    title: 'Video Check',
  },
  {
    path: 'testPhone',
    canActivate: [LoginGuard],
    loadComponent: () => import('./pages/phoneCall/phoneCall.component').then((x) => x.PhoneCallComponent),
    title: 'Phone Call Test',
  },
];
